import { IEmailTemplate } from "../../models/EmailTemplate"

export const EmptyEmailTemplate:IEmailTemplate ={
    template_Id:undefined,
    template_Subject:"",
    template_Name:"",
    template_Body:"",
    is_Share:false
}